import { parseSellerReference } from '../../utils/sellerReference';
import { normalizeCampaignLifecycleStatus } from '../../utils/campaignLifecycleStatus';
import type { CampaignMetadata } from '../../types';
import type { SellerRef } from './SellerActions';
export type SellerCampaignCount = { active: number; paused: number; archived: number; total: number };
/** Explicit seller IDs win; campaigns without a seller belong to the default team seller. */
export function sellerCampaignCounts(campaigns: Pick<CampaignMetadata, 'id' | 'seller_lvl1' | 'seller_name' | 'status'>[], sellers: SellerRef[], teamSellerId?: string) {
  const result = new Map(sellers.map(s => [s.id, { active: 0, paused: 0, archived: 0, total: 0 }]));
  const seen = new Set<string>();
  for (const campaign of campaigns) {
    if (seen.has(campaign.id)) continue;
    seen.add(campaign.id);
    const reference = parseSellerReference(campaign.seller_lvl1);
    const name = campaign.seller_name?.trim().toLowerCase();
    const matches = name ? sellers.filter(s => s.label.trim().toLowerCase() === name) : [];
    const id = reference?.id || (name ? matches.length === 1 ? matches[0].id : undefined : teamSellerId);
    const counts = id ? result.get(id) : undefined;
    if (!counts) continue;
    counts[normalizeCampaignLifecycleStatus(campaign.status) ?? 'active']++;
    counts.total++;
  }
  return result;
}
